interface Props {
  stroke?: string;
  width?: string;
  height?: string;
  className?: string;
}

const KettleBell = ({
  stroke = '#3A99D8',
  width = '48',
  height = '48',
  className = 'KettleBell',
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 48 48"
    version="1.1"
    viewBox="0 0 48 48"
    xmlSpace="preserve"
    className={className}
    width={width}
    height={height}
    transform="scale(1.3)"
  >
    <g>
      <path
        d="M35 21.2c-.6-.7-.9-1.7-1-2.6 0-.3 0-.7.1-.9.4-1.9 1.2-10-9.2-9.6h-1.7c-10-.2-9.3 7.8-8.9 9.6.1.2.1.5.1.8 0 1-.4 1.9-1 2.7-1.6 2-2.5 4.4-2.5 7 0 6.6 6 11.9 13.3 11.9 7.3 0 13.3-5.3 13.3-11.9-.1-2.7-1-5.1-2.5-7z"
        style={{
          fill: 'none',
          stroke,
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="M28 18.8c-2.7-.6-5.2-.6-7.6 0-2.1 0-2.5-1.4-2.5-3.2v-.7c0-1.7 1.4-3.2 3.2-3.2 2.2.3 4.3.3 6.3 0 1.7 0 3.2 1.4 3.2 3.2v.7c-.2 1.8-.5 3.2-2.6 3.2z"
        style={{
          fill: 'none',
          stroke,
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="M16.7 29.5c0-3.6 3.7-6.5 8.2-6.5"
        style={{
          fill: 'none',
          stroke,
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="M32.1 28.3c0 3.6-3.7 6.5-8.2 6.5"
        style={{
          fill: 'none',
          stroke,
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
        }}
      />
    </g>
  </svg>
);

export default KettleBell;
